// Modal de cadastro/edicao de bairro.
// Quando cepUnico=true, o CEP já vem preenchido com o CEP único e travado
// (todos os bairros usam o mesmo; dono, 26/10/2026). O valor de entrega é
// digitado de caixa registradora: cada dígito entra pela direita.

import { Edit, MapPin, Plus } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { InputDecimal } from "../../../components/ui/input-decimal";
import { Label } from "../../../components/ui/label";
import { formatCep } from "../lib/cep";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";

export default function BairroFormDialog({
  open,
  onOpenChange,
  editando,
  formData,
  setFormData,
  saving,
  onSalvar,
  cepUnico,
  cepUnicoValue,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {editando ? <Edit className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
            {editando ? "Editar Bairro" : "Novo Bairro"}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label>Nome do Bairro *</Label>
            <Input
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              placeholder="Ex: Centro"
              className="mt-1"
            />
          </div>

          <div>
            <Label>Valor de Entrega (R$)</Label>
            <InputDecimal
              data-e2e="bairro-valor-entrega"
              decimals={2}
              value={formData.valor_entrega}
              onChange={(v) => setFormData({ ...formData, valor_entrega: v })}
              className="mt-1 text-left"
            />
          </div>

          <div>
            <Label>CEP</Label>
            {cepUnico ? (
              <>
                <Input
                  data-e2e="bairro-cep"
                  value={formatCep(cepUnicoValue)}
                  readOnly
                  className="mt-1 bg-muted/50 cursor-not-allowed"
                />
                <p className="text-xs text-muted-foreground mt-1">
                  <MapPin className="w-3 h-3 inline mr-1" />
                  CEP único da loja. Para usar outro, desligue o CEP Único.
                </p>
              </>
            ) : (
              <Input
                data-e2e="bairro-cep"
                value={formData.cep}
                onChange={(e) => setFormData({ ...formData, cep: formatCep(e.target.value) })}
                placeholder="99999-999"
                inputMode="numeric"
                maxLength={9}
                className="mt-1"
              />
            )}
          </div>

          <div className="flex gap-2 pt-4">
            <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button className="flex-1" onClick={onSalvar} disabled={saving}>
              {saving ? "Salvando..." : "Salvar"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
